import { Injectable } from '@angular/core';

/**
 * IMPORTANT: It might at first glance seem like storing
 * submission state per process is not waranted. This is
 * incorrect, if the user is waiting for a long validation
 * this state is stored so that if they switch to the process
 * tab and back, their submission spinner is not lost.
 * If they want they can still cancel the spinner. Actually
 * this does not cancel the submission process but at least 
 * the user feels free to make adjustments and try a different
 * configuration. This service therefore stores the validating
 * state between volatile component instances.
 */
@Injectable({ providedIn: 'root' })
export class SubmissionStateService {
  private submittingMap = new Map<string, boolean>();

  getSubmitting(key: string): boolean {
    return this.submittingMap.get(key) ?? false;
  }
  setSubmitting(key: string, value: boolean): void {
    this.submittingMap.set(key, value);
  }
}
